var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from "~/core/decorator";
var SmartCollectionService = /** @class */ (function () {
    function SmartCollectionService() {
    }
    /**
     * 智能发送短信数据查询
     */
    SmartCollectionService.prototype.getAllCollectionCaseInfo = function (data, page, sort) {
        return this.netService.send({
            server: domainService.smartCollectionController.getAllCollectionCaseInfo,
            data: data,
            page: page,
            sort: sort
        });
    };
    /**
     * 获取发送短信的联系人列表
     * @param data
     */
    SmartCollectionService.prototype.getPersonalContacts = function (data) {
        return this.netService.send({
            server: domainService.smartCollectionController.getPersonalContacts,
            data: data,
        });
    };
    /**
     * 批量发送短信
     * @param data
     */
    SmartCollectionService.prototype.batchSendMessage = function (data) {
        return this.netService.send({
            server: domainService.smartCollectionController.batchSendMessage,
            data: data,
            option: true
        });
    };
    /**
     * 批量发邮件
     * @param data
     */
    SmartCollectionService.prototype.batchSendMail = function (data) {
        return this.netService.send({
            server: domainService.smartCollectionController.batchSendMail,
            data: data,
            option: true
        });
    };
    /**
     * 获取邮件发送人列表
     * @param data
     */
    SmartCollectionService.prototype.getMailPersonal = function (data) {
        return this.netService.send({
            server: domainService.smartCollectionController.getMailPersonal,
            data: data,
            option: true
        });
    };
    __decorate([
        Inject(NetService)
    ], SmartCollectionService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], SmartCollectionService.prototype, "getAllCollectionCaseInfo", null);
    __decorate([
        Debounce()
    ], SmartCollectionService.prototype, "batchSendMessage", null);
    __decorate([
        Debounce()
    ], SmartCollectionService.prototype, "batchSendMail", null);
    return SmartCollectionService;
}());
export { SmartCollectionService };
